export const GET_ACTIVE_LOCATION_OPTIONS_PENDING = 'get-active-location-options-request';
export const GET_ACTIVE_LOCATION_OPTIONS_SUCCESS = 'get-active-location-options-success';
export const GET_ACTIVE_LOCATION_OPTIONS_FAILURE = 'get-active-location-options-failure';